import React from 'react';
import PropTypes from 'prop-types';
import StudentAccessDataTable from './StudentAccessDataTable';
import StaffAccessDataTable from './StaffAccessDataTable';
import TableActions from './TableActions';

const USER_TYPE_STAFF = 'staff';

const AccessDataTable = ({
    selectedData,
    data,
    userType,
    onDataChange,
    selectAll,
    generateAccessData
}) => {
    const isStaff = userType === USER_TYPE_STAFF;

    return (
        <div>
            {isStaff ? (
                <StaffAccessDataTable
                    data={data}
                    selectedData={selectedData}
                    onDataChange={onDataChange}
                    selectAll={selectAll}
                />
            ) : (
                <StudentAccessDataTable
                    data={data}
                    selectedData={selectedData}
                    onDataChange={onDataChange}
                    selectAll={selectAll}
                />
            )}

            <TableActions
                selectedCount={selectedData.length}
                totalCount={data.length}
                onGenerateAccessData={generateAccessData}
            />
        </div>
    );
};

AccessDataTable.propTypes = {
    selectedData: PropTypes.arrayOf(PropTypes.object).isRequired,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    userType: PropTypes.string.isRequired,
    onDataChange: PropTypes.func.isRequired,
    selectAll: PropTypes.func.isRequired,
    generateAccessData: PropTypes.func.isRequired
};

export default AccessDataTable;



// WEBPACK FOOTER //
// ./src/views/GenerateUsers/AccessDataTable.js